<div class="tree-root">
  <h2>Déclinaisons</h2>

  <!-- <button mat-button (click)="updateProductAttributeValues.emit(formGroup)">Test bidon</button>
  <div *ngIf="formGroup" >
    {{ nodes | json}}
    {{ formGroup.value | json}}
  </div> -->

  <ul class="tree-grid"
    [style.--indent-step.px]="indentStep"
    [style.--label-col.px]="labelColPx"
    [style.--input-col]="'100%'"
    >
    @for (node of flatNodes; track node) {
      <li class="tree-row"
        [style.--level]="node.level">
        <span class="node-label" >{{ node.val_name }}</span>
        <!--<app-search-product></app-search-product>-->
        @if (node.isLeaf) {
          <div class="leaf-input" >
            <app-search-product (selectProductEmitter)="selectProduct($event,node)" [clearButtonVisible]="false" [smallHeight]="true"  [placeholder]="node.val_name_combine" style="width: 280px;"></app-search-product>
            <!-- <button type="button" *ngIf="node.product" mat-button class="error" (click)="detachProduct(node.product )"><mat-icon>delete</mat-icon></button> -->
            @if (node.product) {
              <button type="button" class="custom-icon-button error"  (click)="detachProduct(node.product )"><mat-icon>delete</mat-icon></button>
            }
            <!-- <a *ngIf="node.product" mat-button class="primary" href="#" [routerLink]="['/sales/variant', node.product.template, node.product.id]" target="_blank">{{ node.product.id }}&nbsp;{{ node.product.name }}</a> -->
            @if (node.product) {
              <a mat-button class="primary" href="#" [routerLink]="['/sales/product', node.product.id]" >{{ node.product.id }}&nbsp;{{ node.product.name }}</a>
            }
          </div>
        }
        <!-- <input *ngIf="node.isLeaf"
        type="text"
        class="leaf-input"
        [placeholder]="node.val_name_combine" /> -->
        <!-- placeholder pour occuper la 2e colonne quand ce n'est pas une feuille -->
        @if (!node.isLeaf) {
          <span></span>
        }
      </li>
    }
  </ul>
</div>



<!--
<div class="tree-root">
  <h2>Déclinaisons</h2>
  <ul class="tree-list">
    <li *ngFor="let node of flatNodes ; let i =index " [style.marginLeft.px]="node.level * 50">
      <span class="node-label">{{ node.val_name }}</span>
      <input *ngIf="node.isLeaf" type="text" class="leaf-input" [placeholder]=" node.val_name_combine" />
    </li>
  </ul>
</div> -->
